<div class="severity-cell" [ngClass]="variant()">
    <div class="dot"></div>
    <div class="title">{{ title() }}</div>
</div>
